/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-10 20:34:18
 * @LastEditTime: 2020-06-12 09:21:32
 * @LastEditors:
 */

/** @format */
import logLogin from './logLogin';
import applicationResources from './applicationResources';
import organization from './organization'
import userList from './userList'
import common from './common'
import roleList from './roleList'
import dataAuth from './dataAuth'

const enList = { ...applicationResources, ...logLogin, ...organization, ...userList, ...common, ...roleList, ...dataAuth };
const en_US = {
  "basic": {
    "code-001": "closeAll",//关闭所有
    "code-002": "closeOther",//关闭所有
    "code-003": "switchTab",
    "code-004": "Test select",
    "code-005": "Please enter keywords",
    "code-006": "Dtyunxi Copyright",

    "code-007": "Set up successfully",
    "code-008": "Send verification code successfully",
    "code-009": "Unknown SMS verification code error",
    "code-0010": "Mobile number cannot be empty",
    "code-0011": "Mobile number format error",
    "code-0012": "Get verification code",
    "code-0013": "verification code",
    "code-0014": "Please enter your verification code",
    "code-0015": "submit",
    "code-0016": "reset",
    "code-0017": "mobile number",
    "code-0018": "Please enter your mobile number",

    "code-0019": "Unknown reset password exception",
    "code-0020": "To change the password, you need to log in first",
    "code-0021": "Write off successfully",
    "code-0022": "Change Password",
    "code-0023": "Cancellation",
    "code-0024": "reset password",
    "code-0025": "new password",
    "code-0026": "Please enter your new password",
    "code-0027": "Password must be composed of 6-18 digits, letters or underscores",
    "code-0028": "Confirm password",
    "code-0029": "Reenter password",
    "code-0030": "The two inputs are inconsistent",

    "code-0031": "Unknown login exception",
    "code-0032": "Load user information...",
    "code-0033": "ARM FRAME",
    "code-0034": "Please fill in the user name",
    "code-0035": "Please fill in the password",
    "code-0036": "Please fill in the verification code",
    "code-0037": "Sign in",
    "code-0038": "Dtyunxi",

    "code-0039": "Page not found",
    
    "code-0040": "Admin"
  },
  appName: {
    loc: 'Bussiness Operation Center(loc)',
    dev: 'Bussiness Operation Center(dev)',
    demo: 'Bussiness Operation Center',
    test: 'Bussiness Operation Center(test)',
    stage: 'Bussiness Operation Center(inte)'
  },
  header : {
    newMessage: 'New Message',
    onlineSupport: 'Online Support',
    hotlineSupport: 'Hot Line Support',
    application: 'Application'
  },
  login: {
    appName: 'Bussiness Operation Center',
    account: {
      placeholeder: 'Please enter your account number',
      nulltips: 'Please fill in the user account'
    },
    pwd: {
      placeholeder: 'Please input a password',
      nulltips: 'Please fill in the user password'
    },
    vertifiCode: {
      placeholeder: 'Please enter the verification code',
      error: 'Please fill in the verification code'
    },
    btn: {
      text: 'Sign in'
    },
    copy: {
      name: 'Dtyunxi'
    }
  },
  productList: {
    'code-0001': 'Account number',
    'code-0002': 'User identity',
    'code-0003': 'Schedule',
    'code-0004': 'New items（today）',
    'code-0005': 'Schedule statistics（today）',
    'code-0006':
      'Statistics of resource access times and duration of each application menu (Chart) - accumulated by month',
    'code-0007': 'Total number of visitors',
    'code-0008': 'Application administrator'
  },
  tenantDetail: {
    'code-0001': 'Tenant information',
    'code-0002': 'Tenant number',
    'code-0003': 'Tenant name',
    'code-0004': 'Tenant administrator account',
    'code-0005': 'Tenant administrator contact',
    'code-0006': 'Application authorized',
    'code-0007': 'Apply number',
    'code-0008': 'Apply name',
    'code-0009': 'Apply template',
    'code-0010': 'Access portal',
    'code-0011': 'State',
    'code-0012': 'Detailed',
    'code-0013': 'Prohibit',
    'code-0014': 'Query condition',
    'code-0015': 'User name',
    'code-0016': 'Creation time',
    'code-0017': 'List of tenant administrators',
    'code-0018': 'New administrator',
    'code-0019': 'Alias',
    'code-0020': 'Mobile phone number',
    'code-0021': 'Mailbox',
    'code-0022': 'Edit',
    'code-0023': 'Prohibit',
    'code-0024': 'Change password',
    'code-0025': 'Delete',
    'code-0026': 'Enable',
    'code-0027': 'Create tenant administrator',
    'code-0028': 'Edit tenant administrator',
    'code-0029': 'Confirm',
    'code-0030': 'Cancel',
    'code-0031': 'New password',
    'code-0032': 'Confirm new password',
    'code-0033': 'Password',
    'code-0034': 'Please enter tenant administrator user name',
    'code-0035': 'Please enter the login password',
    'code-0036': 'Please enter tenant administrator alias',
    'code-0037': 'Please enter your mobile number',
    'code-0038': 'Please enter email',
    'code-0039': 'Please enter tenant administrator user name！',
    'code-0040': 'Password cannot be empty',
    'code-0041': 'Alias cannot be empty',
    'code-0042': 'User name can only enter numbers, letters or underscores, within 20 characters',
    'code-0043': 'Passwords are two or more combinations of numbers, letters and special symbols',
    'code-0044': 'Alias cannot be longer than 20 characters',
    'code-0045': 'Wrong mobile number',
    'code-0046': 'Please enter the correct email format',
    'code-0047': 'New password cannot be empty',
    'code-0048': 'Confirm new password cannot be empty',
    'code-0049': 'Passwords are two or more combinations of numbers, letters and special symbols',
    'code-0050': 'Please enter new password'
  }
};

export default { ...en_US, ...enList };



// WEBPACK FOOTER //
// ./src/config/langs/en_US/index.js